// extracted by mini-css-extract-plugin
export var colorSquare = "_rb-0";
export var danger = "_rb-5";
export var lightPink = "_rb-8";
export var neutralBlue = "_rb-7";
export var neutralYellow = "_rb-6";
export var normal = "_rb-1";
export var primary = "_rb-2";
export var primaryLight = "_rb-3";
export var solidBlack = "_rb-g";
export var solidGreen = "_rb-b";
export var solidLightBlue = "_rb-d";
export var solidNavy = "_rb-c";
export var solidOrange = "_rb-f";
export var solidPink = "_rb-e";
export var solidRed = "_rb-9";
export var solidYellow = "_rb-a";
export var success = "_rb-4";